<template>
  <iColumn gap="standard" width="fill" data-test="blocked-people-section">
    <iColumn gap="extraSmall" width="fill">
      <iText font-weight="dark">
        Blocked people
      </iText>
      <iText variant="subtle" font-size="small">
        You don't see their comments or replies on this destination, or their messages in its chat.
      </iText>
    </iColumn>
    <iLoadingSpinner v-if="loading" size="small" />
    <iText
      v-else-if="people.length === 0"
      variant="subtle"
      font-size="small"
      data-test="blocked-people-empty"
    >
      You haven't blocked anyone.
    </iText>
    <iRow
      v-for="person in people"
      :key="person.userId"
      gap="small"
      vertical-align="middle"
      width="fill"
      wrap="nowrap"
      data-test="blocked-person"
    >
      <iAvatar :name="person.name" :src="person.avatarUrl" size="small" />
      <iText font-size="small" width="fill" data-test="blocked-person-name">
        {{ person.name || "Someone" }}
      </iText>
      <iButton
        variant="secondary"
        size="small"
        :is-loading="unblocking === person.userId"
        data-test="blocked-person-unblock"
        @click="unblock(person)"
      >
        Unblock
      </iButton>
    </iRow>
    <iText
      v-if="error"
      variant="error"
      font-size="small"
      data-test="blocked-people-error"
    >
      {{ error }}
    </iText>
  </iColumn>
</template>

<script>
import App from "@bloglovin/inspire-engine/App";
import { useStoryCommentsStore } from "%/dynamic-component-editor/stores/story-comments-store";
import { USER_BLOCKING_APP, USER_BLOCK_ENTITY_TYPE } from "%/dynamic-component-editor/constants/story-engagement-constants.mjs";

const CONFIGURATION_ENTITY_TYPE = "Configuration";
const BLOCKS_FIELD = "myBlocks";
const USER_ENTITY_TYPE = "User";

export default {
  name: "BlockedPeopleSection",
  props: {
    configurationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      unblocking: 0,
      error: "",
    };
  },
  computed: {
    userBlocking() {
      return App.get(USER_BLOCKING_APP);
    },
    blocks() {
      return this.userBlocking.getFeedStore(CONFIGURATION_ENTITY_TYPE, { id: this.configurationId }, BLOCKS_FIELD);
    },
    loading() {
      return !this.blocks.hasLoadedAtLeastOnce;
    },
    people() {
      return this.blocks.items.map(item => {
        const userId = this.userBlocking.getEntityField(USER_BLOCK_ENTITY_TYPE, item.entityPk, "blocked").pk.id;
        return {
          userId,
          name: this.userBlocking.getEntityField(USER_ENTITY_TYPE, { id: userId }, "name"),
          avatarUrl: this.userBlocking.getEntityField(USER_ENTITY_TYPE, { id: userId }, "avatar"),
        };
      });
    },
  },
  mounted() {
    this.blocks.triggerInitialLoad();
  },
  methods: {
    unblock(person) {
      this.error = "";
      this.unblocking = person.userId;
      useStoryCommentsStore().unblockPerson(person).catch(error => {
        this.error = error.message;
      }).finally(() => {
        this.unblocking = 0;
      });
    },
  },
};
</script>
